// extracted by mini-css-extract-plugin
export default {"tooltip":"customTooltip_tooltip__MUfh8","label":"customTooltip_label__Fa+FL"};